import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'
import { Lang } from "../wallet/product.model";
import i18n from '@/utils/i18n.utils';

interface SettingsState {
  language: Lang,
  brandName: string,
}

interface SettingsActions {
  setLanguage: (language: Lang) => void;
  setBrandName: (brandName: string) => void;
  getLanguage: () => Lang;
  getBrandName: () => string;
}

export const SettingsStore = create<SettingsState & SettingsActions>()(
  persist(
    (set, get) => (
      {
        language: 'EN',
        brandName: '',
        setLanguage: language => {
          set({ language });
          i18n.changeLanguage(language);
        },
        setBrandName: brandName => {
          set({ brandName });
        },
        getLanguage: () => {
          const { language } = get();
          return language;
        },
        getBrandName: () => {
          const { brandName } = get();
          return brandName;
        }
      }
    ),
    {
      name: "_settings_wallet_storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
)